export const locales = ["en", "de", "fr", "ru", "es", "cn", "am"];
